import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/admin_log/index',
    method: 'get',
    params
  })
}

export function getDetail(id) {
  return request({
    url: `/admin_log/detail/${id}`,
    method: 'get'
  })
}

export function deleteLog(id) {
  return request({
    url: `/log/${id}`,
    method: 'delete'
  })
}

export function clearLog(data) {
  return request({
    url: '/log/clear',
    method: 'delete',
    data
  })
}
